var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 59,
    viewBox: "0 0 75 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.27979 34.0972H73.1935",
    stroke: "#FAC02C",
    strokeWidth: 3.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9141 34.9306V42.2521H46.6561V34.597",
    stroke: "#FAC02C",
    strokeWidth: 3.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4158 11.0332V48.3796C73.4158 53.2871 69.4313 57.2716 64.5238 57.2716H11.1718C6.26431 57.2716 2.27979 53.2871 2.27979 48.3796V11.0332C2.27979 6.1257 6.26431 2.14117 11.1718 2.14117H64.5238C69.4313 2.14117 73.4158 6.1257 73.4158 11.0332Z",
    stroke: "#121330",
    strokeWidth: 3.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.8c1d4d298ee9c79f9571e7932ed7134e.svg";
export { ForwardRef as ReactComponent };